export default __webpack_public_path__ + "static/media/Carla_Hatler_AHV_In_Moms_We_Trust.ccea1455.jpg";